import type { SVGProps } from 'react'

export const Trash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox='0 0 74 74'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ fill: 'none' }}
    {...props}
  >
    <path
      d='M9.25 18.4994H15.4167M15.4167 18.4994H64.75M15.4167 18.4994L15.4167 61.666C15.4167 63.3015 16.0664 64.87 17.2228 66.0265C18.3793 67.183 19.9478 67.8327 21.5833 67.8327H52.4167C54.0522 67.8327 55.6207 67.183 56.7772 66.0265C57.9336 64.87 58.5833 63.3015 58.5833 61.666V18.4993M24.6667 18.4993V12.3327C24.6667 10.6972 25.3164 9.12866 26.4728 7.97219C27.6293 6.81572 29.1978 6.16602 30.8333 6.16602H43.1667C44.8022 6.16602 46.3707 6.81572 47.5272 7.97219C48.6836 9.12866 49.3333 10.6972 49.3333 12.3327V18.4993M30.8333 33.916V52.416M43.1667 33.916V52.416'
      stroke='white'
      strokeWidth='6'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

Trash.toString = () => 'trash'
